import React from 'react';
import {FmlaEventConfigComponent} from './FmlaEventConfig.Component';
import {httpServices}  from '../../../../services/httpServices';

const formFields = {
    'fmla_type_id' : '',
    'start_date' : null,
    'end_date' : null,
    'notes' : null,
}

export class FmlaEventConfigContainer extends React.Component {
    constructor(props){
        super(props)
        this.state ={
            staff_fmla_events : [],
            open : false,
            fmla_event_types : [],
            formFields : formFields,
            isEdit : false,
            errors: {},
            variant : 'success',
            snackbar : false,
        }
        this.onAddFmlaEvent = this.onAddFmlaEvent.bind(this);
        this.onClose = this.onClose.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.saveStaffFmlaEvent = this.saveStaffFmlaEvent.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.onDelete = this.onDelete.bind(this);
      	this.snackbarClose = this.snackbarClose.bind(this);
    }
    componentDidMount() {
        if (Array.isArray(this.props.StaffFmlaEvents)) {
          this.setState({
            staff_fmla_events: this.props.StaffFmlaEvents
          });
        }
    }
    componentDidUpdate(prevProps) {
        if ( prevProps.StaffFmlaEvents !== this.props.StaffFmlaEvents && this.props.StaffFmlaEvents ) {
            this.setState({
                staff_fmla_events: this.props.StaffFmlaEvents
            });
        }
    }
    onAddFmlaEvent = () => {
          return httpServices.post('api/timeoff/getFmlaEvents', {})
            .then(response => {
                if (response.data) {
                    this.setState({
                        fmla_event_types :response.data.fmla_events_types,
                        open : true
                    });
                }
            })
    }
    onClose = () =>{
        this.setState({
            open: false,
            id: 0,
            errors:{}
        });
	    this.clearForm();
    } 
    snackbarClose = () => {
        this.setState({
            snackbar : false,
        });
    }
    clearForm = () => {
        const ff = this.state.formFields;
        for (let key in ff) {
            ff[key] = null;
        }
        this.setState({
            errors: {},
            formFields: ff,
            isEdit : false
        });
    };    
    handleOnChange = (evt, value) => {
        const f = this.state.formFields;
        const name = evt.target.name;
        f[name] = evt.target.value;
        this.setState({
            formFields: f
        });
        if (value) {
            this.setState({errors: {}});
        }
    };
    handleDateChange = (value, name) => {
        const f = this.state.formFields;
        f[name] = value;
        this.setState({
            formFields: f
        })
    };

    saveStaffFmlaEvent = () => {
    	if (this.handleValidation()) {
            this.setState({buttonLoader : true});
            const data = this.state.formFields;
            data.staff_id = this.props.StaffID;
            data.user_id = this.props.UserID;
            const currentYear = new Date().getFullYear();
            data.filter_year = this.props.YearVal && !isNaN(this.props.YearVal) ? this.props.YearVal : currentYear;
            return httpServices.post('api/timeoff/saveStaffFmlaEvent', data)
                .then(response => {
                    if (response.data.valid) {
                            this.setState({
                                open:false,
                                snackbar : true,
                                variant : 'success',
                                message : response.data.message,
                                staff_fmla_events : response.data.staff_fmla_events,
                                buttonLoader : false,
                            });
                            this.clearForm();
                    }
                    else {
                        this.setState({
                                snackbar : response.data.errors ? true : false,
                                variant : 'error',
                                message : response.data.errors,
                                errors : response.data.field_errors ? response.data.field_errors : '',
                                buttonLoader : false,
                            });
                    }
                })
                .catch(function(error) {
                    console.log("Error: "+error);
                });
        }
    }        
        
    handleValidation() {
        let formIsValid = true;
        let errors = {};
        if (!this.state.formFields.fmla_type_id) {
            errors["fmla_type_id"] = "Cannot be empty";
            formIsValid = false;
        }
        if (!this.state.formFields.start_date) {
            errors["start_date"] = "Cannot be empty";
            formIsValid = false;
        }
        if (!this.state.formFields.end_date) {
            errors["end_date"] = "Cannot be empty";
            formIsValid = false;
        }
        if(this.state.formFields.start_date && this.state.formFields.start_date){
            let start_date = new Date(this.state.formFields.start_date);
            let end_date = new Date(this.state.formFields.end_date);
            if(start_date > end_date){
                errors["start_date"] = "Please enter valid dates";
                formIsValid = false;
            }
        }
        this.setState({errors: errors});
        return formIsValid;
    }
    onUpdate = (id) => {
        return httpServices.post('api/timeoff/getFmlaEvents', {'id': id})
        .then(response => {
               if (response.data) {
                    this.setState({
                        fmla_event_types : response.data.fmla_events_types,
                        formFields: response.data.selected_fmla_event,
                        open: true, 
                        id: id,
                        isEdit: true,
                    });
                }      
        })
        .catch(function(error) {
            console.log("Error: "+error);
        });
    }

    onDelete = (rowData) => {
        const staffID = this.props.StaffID;
        const userID = this.props.UserID;
        const currentYear = new Date().getFullYear();
        const filterYear = this.props.YearVal && !isNaN(this.props.YearVal) ? this.props.YearVal : currentYear;
        return httpServices.post('api/timeoff/deleteStaffFmlaEvent', {'id': rowData.id, 'staff_id': staffID, 'user_id': userID, 'filter_year': filterYear, 'start_date' : rowData.start_date, 'end_date': rowData.end_date, 'fmla_type_id' : rowData.fmla_type_id})
            .then(response => {
            if (response.data.valid) {
                this.setState({
                    snackbar : true,
                    variant : 'success',
                    message : response.data.message,
		            staff_fmla_events : response.data.staff_fmla_events
                });
            }
            else {
                this.setState({
                    snackbar : true,
                    variant : 'error',
                    message : response.data.message,
                    staff_fmla_events : response.data.staff_fmla_events
                });

            }
        })
        .catch(function(error) {
            console.log("Error: "+error);
        });
    }
    render(){
        return(
            <FmlaEventConfigComponent
                StaffFmlaEventList = { this.state.staff_fmla_events }
                OnAddFmlaEvent = { this.onAddFmlaEvent }
                FmlaEventTypes = { this.state.fmla_event_types }
                Open = { this.state.open }
                Close = { this.onClose }
                HandleOnChange = { this.handleOnChange }
                HandleDateChange = { this.handleDateChange }
                FormFields = { this.state.formFields }
                SaveStaffFmlaEvent = { this.saveStaffFmlaEvent }
                HandleUpdate = { this.onUpdate }
                IsEdit = { this.state.isEdit }
                OnDelete = { this.onDelete }
                Errors = {this.state.errors}
                Variant = {this.state.variant}
                Message = {this.state.message}
                Snackbar = {this.state.snackbar}
                SnackbarClose = {this.snackbarClose}
            />                    
       
        )
    }
}


     
